import React from 'react'

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="135"
    height="40"
    overflow="visible"
    viewBox="0 0 135 40"
  >
    <path d="M130 40H5c-2.75 0-5-2.25-5-5V5c0-2.75 2.25-5 5-5h125c2.75 0 5 2.25 5 5v30c0 2.75-2.25 5-5 5z"></path>
    <path
      fill="#a6a6a6"
      d="M130 .8a4.2 4.2 0 014.2 4.2v30a4.2 4.2 0 01-4.2 4.2H5A4.2 4.2 0 01.8 35V5A4.2 4.2 0 015 .8h125m0-.8H5C2.25 0 0 2.25 0 5v30c0 2.75 2.25 5 5 5h125c2.75 0 5-2.25 5-5V5c0-2.75-2.25-5-5-5z"
    ></path>
    <path
      fill="#fff"
      stroke="#fff"
      strokeMiterlimit="10"
      strokeWidth="0.2"
      d="M47.42 10.24c0 .84-.25 1.51-.75 2-.56.59-1.3.89-2.2.89-.87 0-1.6-.3-2.21-.9-.61-.6-.91-1.35-.91-2.23 0-.89.3-1.63.91-2.23.61-.6 1.34-.9 2.21-.9.43 0 .84.08 1.23.25.39.17.7.39.94.67l-.53.53c-.4-.47-.94-.71-1.64-.71-.63 0-1.18.22-1.64.67-.46.44-.69 1.02-.69 1.73s.23 1.29.69 1.73c.46.44 1.01.67 1.64.67.67 0 1.23-.22 1.68-.67.29-.29.46-.7.5-1.22h-2.18v-.73h2.91c.02.16.04.31.04.45zm4.61-2.5H49.3v1.9h2.46v.72H49.3v1.9h2.73V13h-3.5V7h3.5v.74zM55.28 13h-.77V7.74h-1.68V7h4.12v.74h-1.68V13zm4.66 0V7h.77v6h-.77zm4.19 0h-.77V7.74h-1.68V7h4.12v.74h-1.68V13zm9.48-.78c-.59.61-1.32.91-2.2.91-.88 0-1.61-.3-2.2-.91-.59-.61-.88-1.35-.88-2.22s.29-1.62.88-2.22c.59-.61 1.32-.91 2.2-.91.87 0 1.6.3 2.2.91.59.61.89 1.35.89 2.22-.01.88-.3 1.62-.89 2.22zm-3.83-.5c.44.45.99.67 1.63.67.64 0 1.19-.22 1.63-.67.44-.45.67-1.02.67-1.72s-.22-1.27-.67-1.72c-.44-.45-.99-.68-1.63-.68-.64 0-1.19.22-1.63.67-.44.46-.67 1.03-.67 1.73s.23 1.27.67 1.72zm5.8 1.28V7h.94l2.92 4.67h.03l-.03-1.16V7h.77v6h-.8l-3.05-4.89h-.03l.03 1.16V13h-.78z"
    ></path>
    <path
      fill="#fff"
      d="M68.14 21.75c-2.35 0-4.27 1.79-4.27 4.25 0 2.45 1.92 4.25 4.27 4.25 2.35 0 4.27-1.8 4.27-4.25 0-2.46-1.92-4.25-4.27-4.25zm0 6.83c-1.29 0-2.4-1.06-2.4-2.58 0-1.53 1.11-2.58 2.4-2.58 1.29 0 2.4 1.05 2.4 2.58 0 1.52-1.12 2.58-2.4 2.58zm-9.32-6.83c-2.35 0-4.27 1.79-4.27 4.25 0 2.45 1.92 4.25 4.27 4.25 2.35 0 4.27-1.8 4.27-4.25 0-2.46-1.92-4.25-4.27-4.25zm0 6.83c-1.29 0-2.4-1.06-2.4-2.58 0-1.53 1.11-2.58 2.4-2.58 1.29 0 2.4 1.05 2.4 2.58 0 1.52-1.11 2.58-2.4 2.58zm-11.08-5.52v1.8h4.32c-.13 1.01-.47 1.76-.98 2.27-.63.63-1.61 1.32-3.33 1.32-2.66 0-4.74-2.14-4.74-4.8s2.08-4.8 4.74-4.8c1.43 0 2.48.56 3.25 1.29l1.27-1.27c-1.08-1.03-2.51-1.82-4.53-1.82-3.64 0-6.7 2.96-6.7 6.61 0 3.64 3.06 6.61 6.7 6.61 1.97 0 3.45-.64 4.61-1.85 1.19-1.19 1.56-2.87 1.56-4.22 0-.42-.03-.81-.1-1.13h-6.07zm45.31 1.4c-.35-.95-1.43-2.71-3.64-2.71-2.19 0-4.01 1.72-4.01 4.25 0 2.38 1.8 4.25 4.22 4.25 1.95 0 3.08-1.19 3.54-1.88l-1.45-.97c-.48.71-1.14 1.18-2.09 1.18s-1.63-.44-2.06-1.29l5.69-2.35-.2-.48zm-5.8 1.42c-.05-1.64 1.27-2.48 2.22-2.48.74 0 1.37.37 1.58.9l-3.8 1.58zM82.63 30h1.87V17.5h-1.87V30zm-3.06-7.3h-.07c-.42-.5-1.22-.95-2.24-.95-2.13 0-4.08 1.87-4.08 4.27 0 2.38 1.95 4.24 4.08 4.24 1.01 0 1.82-.45 2.24-.97h.06v.61c0 1.63-.87 2.5-2.27 2.5-1.14 0-1.85-.82-2.14-1.51l-1.63.68c.47 1.13 1.71 2.51 3.77 2.51 2.19 0 4.04-1.29 4.04-4.43v-7.64h-1.77v.69zm-2.15 5.88c-1.29 0-2.37-1.08-2.37-2.56 0-1.5 1.08-2.59 2.37-2.59 1.27 0 2.27 1.1 2.27 2.59.01 1.48-.99 2.56-2.27 2.56zm24.39-11.08h-4.47V30h1.87v-4.74h2.61c2.07 0 4.1-1.5 4.1-3.88s-2.05-3.88-4.11-3.88zm.04 6.02H99.2v-4.29h2.65c1.4 0 2.19 1.16 2.19 2.14 0 .98-.79 2.15-2.19 2.15zm11.54-1.79c-1.35 0-2.75.6-3.33 1.91l1.66.69c.35-.69 1.01-.92 1.7-.92.97 0 1.95.58 1.96 1.61v.13c-.34-.19-1.06-.48-1.95-.48-1.79 0-3.6.98-3.6 2.81 0 1.67 1.46 2.75 3.1 2.75 1.25 0 1.95-.56 2.38-1.22h.06v.97h1.8v-4.79c.01-2.22-1.65-3.46-3.78-3.46zm-.23 6.85c-.61 0-1.46-.31-1.46-1.06 0-.96 1.06-1.33 1.98-1.33.82 0 1.21.18 1.7.42a2.257 2.257 0 01-2.22 1.97zM123.74 22l-2.14 5.42h-.06L119.32 22h-2.01l3.33 7.58-1.9 4.21h1.95L125.82 22h-2.08zm-16.8 8h1.87V17.5h-1.87V30z"
    ></path>
    <linearGradient
      id="a"
      x1="21.8"
      x2="5.017"
      y1="173.29"
      y2="156.508"
      gradientTransform="matrix(1 0 0 -1 0 182)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#00a0ff"></stop>
      <stop offset="0.007" stopColor="#00a1ff"></stop>
      <stop offset="0.26" stopColor="#00beff"></stop>
      <stop offset="0.512" stopColor="#00d2ff"></stop>
      <stop offset="0.76" stopColor="#00dfff"></stop>
      <stop offset="1" stopColor="#00e3ff"></stop>
    </linearGradient>
    <path
      fill="url(#a)"
      d="M10.44 7.54c-.29.31-.46.79-.46 1.4v22.12c0 .62.17 1.1.46 1.4l.07.07L22.9 20.15v-.3L10.51 7.47l-.07.07z"
    ></path>
    <linearGradient
      id="b"
      x1="33.834"
      x2="9.637"
      y1="161.999"
      y2="161.999"
      gradientTransform="matrix(1 0 0 -1 0 182)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#ffe000"></stop>
      <stop offset="0.409" stopColor="#ffbd00"></stop>
      <stop offset="0.775" stopColor="orange"></stop>
      <stop offset="1" stopColor="#ff9c00"></stop>
    </linearGradient>
    <path
      fill="url(#b)"
      d="M27.03 24.28l-4.13-4.13v-.3l4.13-4.13.09.05 4.89 2.78c1.4.79 1.4 2.09 0 2.89l-4.89 2.78-.09.06z"
    ></path>
    <linearGradient
      id="c"
      x1="24.827"
      x2="2.069"
      y1="159.704"
      y2="136.946"
      gradientTransform="matrix(1 0 0 -1 0 182)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#ff3a44"></stop>
      <stop offset="1" stopColor="#c31162"></stop>
    </linearGradient>
    <path
      fill="url(#c)"
      d="M27.12 24.23L22.9 20 10.44 32.46c.46.49 1.22.55 2.08.06l14.6-8.29"
    ></path>
    <linearGradient
      id="d"
      x1="7.297"
      x2="17.46"
      y1="181.824"
      y2="171.661"
      gradientTransform="matrix(1 0 0 -1 0 182)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#32a071"></stop>
      <stop offset="0.069" stopColor="#2da771"></stop>
      <stop offset="0.476" stopColor="#15cf74"></stop>
      <stop offset="0.801" stopColor="#06e775"></stop>
      <stop offset="1" stopColor="#00f076"></stop>
    </linearGradient>
    <path
      fill="url(#d)"
      d="M27.12 15.78l-14.61-8.3c-.86-.49-1.62-.43-2.08.06L22.9 20l4.22-4.22z"
    ></path>
    <path
      d="M27.03 24.13l-14.52 8.25c-.81.46-1.54.43-2 .01l-.07.07.07.07c.47.42 1.19.45 2-.01l14.61-8.3-.09-.09z"
      opacity="0.2"
    ></path>
    <path
      d="M10.44 32.32c-.29-.31-.46-.79-.46-1.4v.15c0 .62.17 1.1.46 1.4l.07-.07-.07-.08zM32.01 21.3l-4.99 2.83.09.09L32 21.44c.7-.4 1.05-.92 1.05-1.44-.05.47-.4.94-1.04 1.3z"
      opacity="0.12"
    ></path>
    <path
      fill="#fff"
      d="M12.51 7.62l19.5 11.08c.63.36.99.82 1.05 1.3 0-.52-.35-1.05-1.05-1.44L12.51 7.48c-1.4-.79-2.54-.13-2.54 1.47v.15c0-1.61 1.15-2.27 2.54-1.48z"
      opacity="0.25"
    ></path>
  </svg>
)



// WEBPACK FOOTER //
// ./src/ui/components/modules/TryBeforeYouBuy/IconGoogle.js